import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../reducers/auth_reducers';
import { useHistory } from "react-router-dom";
//Material-ui components
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import EditIcon from '@material-ui/icons/Edit';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 860,
    marginTop: '15%',
    border: 'solid 3px #3b384b',
    fontFamily:'panton-bold',
    boxShadow:'15px 20px 10px #777777'
  },
}));

const DashAdmin = () => {

  const [ data, setData ] = useState({users: []})
  const classes = useStyles();
  const [checked, setChecked] = useState([1]);

  let history = useHistory();


  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  //FETCH ALL USERS DATA EXCEPT REGISTERS
  const fetchData = () =>  {
    let config =  { 
      headers: {
        'Authorization': "bearer " + JSON.parse(localStorage.getItem('token'))
      }
    };

    axios.get(
      'https://blooming-spire-64013.herokuapp.com/admin/all',
      config,
      { withCredentials: true })
      .then(response => {
        setData({users: response.data})})
      .catch(err => {
        alert("¡Usuario no autorizado!");
        history.push('/login');

      })
  }

  useEffect(() => {
    fetchData()
  }, ["data.users"])

  let userLocal = JSON.parse(localStorage.getItem('user'))



  return (
    <div style={{"height": "auto", "display": "flex", "justifyContent": "center", "alignItems": "flex-start", marginTop: "120px"}}>
      <List dense className={classes.root}>
      {/* borderBottom: "2px solid black",  */}
        <ListItem   style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <ListItemAvatar>
            {/* <Avatar
              alt="Male avatar"
              src="https://icon-library.net/images/avatar-icon-png/avatar-icon-png-8.jpg"
            /> */}
            </ListItemAvatar>
            <ListItemText  primary={`Nombre de usuario`} />
            {/* <ListItemSecondaryAction > */}
            <div style={{width: "600px", "display": "flex", flexWrap: "wrap", "justifyContent": "flex-end", "alignItems": "center"}}>
              <div style={{margin: "0 5px"}} >Editar</div>
            {/* </ListItemSecondaryAction > */}
            {/* <ListItemSecondaryAction > */}
              <div style={{margin: "0 5px"}} >Subir</div>
            {/* </ListItemSecondaryAction > */}
            {/* <ListItemSecondaryAction > */}
              <div style={{margin: "0 5px"}} >Preview</div>
            {/* </ListItemSecondaryAction> */}
            </div>
            {/* style={{writingMode: "vertical-rl",textOrientation: "mixed", margin: ""}} */}
          </ListItem>
        {
          data.users.length < 1 ? <div>Cargando...</div> : data.users.map((user, index) => {
            const labelId = `checkbox-list-secondary-label-${index}`;
            if(user._id !== userLocal._id  && user.role !== "SuperAdmin"){
            return (
              <ListItem key={user.id} button>
                <ListItemAvatar>
                  <Avatar
                    alt="Male avatar"
                    src="https://icon-library.net/images/avatar-icon-png/avatar-icon-png-8.jpg"
                  />
                  </ListItemAvatar>
                  <ListItemText id={labelId} primary={`${user.firstName} ${user.lastName}`} />
                  <ListItemSecondaryAction style={{ "display": "flex", flexWrap: "wrap", "justifyContent": "flex-end", "alignItems": "center"}}>
                    <Link to={{pathname: `/client-edit/${user.id}`}}>
                      <EditIcon style={{margin: "0 15px"}}/>
                    </Link>
                    <Link to={{pathname: `/reports-upload/${user.id}`}}>
                      <NoteAddIcon style={{margin: "0 15px"}}/>
                    </Link>
                    <Link to={{pathname: `/preview/${user.id}`}}>
                      <VisibilityIcon style={{margin: "0 15px"}}/>
                    </Link>
                  </ListItemSecondaryAction>
                </ListItem>
            );
          }
          })
        }
    </List>
  </div>
  );
}

export default DashAdmin;
